module.exports = __webpack_public_path__ + "img/address_of_contracting.18bf9ee8.svg";